// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.address.RentalManagerUserPropertyAddressWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentalManagerUserPropertyAddressWebApiHandler_update } from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  ListingAlias,
  PropertyType,
  UserPropertyAddressUpdateResponseWebDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface UpdateParams {
  fullAddress: string;
  listingAlias: ListingAlias;
  propertyType?: PropertyType;
  unitNumber?: string;
}

export interface RentalManagerUserPropertyAddressWebApiHandler_update_Args {
  getParams: UpdateParams;
}

export type RentalManagerUserPropertyAddressWebApiHandler_update_Options = UseMutationOptions<
  UserPropertyAddressUpdateResponseWebDto,
  unknown,
  RentalManagerUserPropertyAddressWebApiHandler_update_Args
>;

/**
 * Update address for property
 */
export const useRentalManagerUserPropertyAddressWebApiHandler_update = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyAddressWebApiHandler_update_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyAddressWebApiHandler_update_Args) =>
      RentalManagerUserPropertyAddressWebApiHandler_update(args.getParams, httpClient),
  });
};
